import AdminAutomationSettings from './AdminAutomationSettings';

export default AdminAutomationSettings;
